import { getConfigString } from '@config'
import type { TemperatureUnit } from '@constants/utils'

import { UPDATE_TEMP_UNIT, UPDATE_TEMP_UNIT_GLOBAL } from '../actions'

type State = { tempUnitGlobal: string; tempUnit: string }

export interface TempUnitSocket {
  tempUnitGlobal: TemperatureUnit
  tempUnit: TemperatureUnit
}

interface TempUnitAction {
  type: string
  payload: TemperatureUnit
}

const initialState: State = {
  tempUnitGlobal: getConfigString('model.temperature.tempUnit'),
  tempUnit: getConfigString('model.temperature.tempUnit')
}

export default function init (previousState = initialState, action: TempUnitAction) {
  if (action.type === UPDATE_TEMP_UNIT) {
    localStorage.setItem('tempUnit', action.payload)
    return { ...previousState, tempUnit: action.payload }
  } else if (action.type === UPDATE_TEMP_UNIT_GLOBAL) {
    localStorage.setItem('tempUnitGlobal', action.payload)
    return { ...previousState, tempUnitGlobal: action.payload }
  } else {
    return previousState
  }
}
